export default __webpack_public_path__ + "static/logo-unpaired-d9ac02ab53aae3686a6dbd92dc50d12f.png";